<template>
  <div class="row">
    <div class="col-md-1"></div>
    <div class="col-md-12 col-12">
      <div class="alert w-100" :class="ClassCustom">
        <b class="text-warning" style="font-size: 15px !important"
          >{{ Title }} ،
        </b>
        <span class="text-light">{{ Des != "" ? Des : "" }}</span>
        <i
          v-if="IsBtnBack == true"
          title="بازگشت به صفحه قبلی"
          class="fas fa-arrow-left text-warning Pointer"
          style="float: left; font-size: 18px"
          @click="Back"
        ></i>
        <i
          v-if="IsBtnClose == true"
          title="بازگشت به صفحه قبلی"
          class="fas fa-times text-warning Pointer"
          style="float: left; font-size: 18px"
          data-dismiss="modal"
        ></i>
      </div>
    </div>
    <div class="col-md-1"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["Title", "Des", "ClassCustom", "IsBtnBack", "IsBtnClose"],
  methods: {
    Back() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.bg-dark-Custom {
  background: #2a3f54 !important;
  /* border:1px solid #2A3F54 !important; */
}
</style>
